import { useState, useEffect } from "react";

function usePagination(data, itemsPerPage, open) {
  const [currentPage, setCurrentPage] = useState(1);
  const [searchWord, setSearchWord] = useState('');
  const maxPage = Math.ceil(data.length / itemsPerPage);

  useEffect(()=>{
    setCurrentPage(1);  
  },[open]);
  
  function currentData() {
    const begin = (currentPage - 1) * itemsPerPage;
    const end = begin + itemsPerPage;
    const tempData = data.filter(row =>{
        if (searchWord === '')
        return row;
        else if (row.title.toLowerCase().includes(searchWord.toLowerCase()))
        return row;
        else return false;
    });
    return tempData.slice(begin, end);
  }

  function next() {
    setCurrentPage(currentPage => Math.min(currentPage + 1, maxPage));
  }

  function prev() {
    setCurrentPage(currentPage => Math.max(currentPage - 1, 1));
  }

  function jump(page) {
    const pageNumber = Math.max(1, page);
    setCurrentPage(currentPage => Math.min(pageNumber, maxPage));
  }

  function search(e) {
    setSearchWord(e);
  }
  return { next, prev, jump, currentData, currentPage, maxPage, search };
}

export default usePagination;
